import React from "react";
import LinkToReport from "app/routes/Reporting/ReportContent/LinkToReport";
import PercentageWithChange from "app/routes/Reporting/ReportContent/PercentageWithChange";

export const downloadExport = (url, filename) => {
  fetch(url, {
    method: "GET",
  })
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);

      document.body.appendChild(link);

      link.click();

      link.parentNode.removeChild(link);
    });
};

export const calculateTableContainerHeight = (report, queryParams) => {
  let tableContainerHeight;

  if (report.filters.filter((filter) => filter.primary === true).length > 0) {
    if (
      queryParams.get("period") === "custom" ||
      queryParams.get("comparison_period") === "custom"
    ) {
      tableContainerHeight = 427;
    } else {
      tableContainerHeight = 307;
    }
  } else {
    tableContainerHeight = 186;
  }

  if (report.filters.filter((filter) => filter.primary === true).length > 2) {
    tableContainerHeight += 101;
  }

  if (report.hasPagination === false) {
    tableContainerHeight -= 60;
  }

  return tableContainerHeight;
};

const formatters = {
  coach_activity_by_athlete: {
    studentHandle: (field_name, row) => {
      if (!row[field_name]) {
        return "";
      }
      const students = row[field_name].split(",").map((s) => s.trimEnd());
      const values = students.map((name, idx) => {
        return (
          <LinkToReport
            key={row.id}
            path="/reports/coach_activity_by_athlete"
            id="coach_activity_by_athlete"
            query={{ student_id: row.studentIds[idx], student_id_name: name }}
            label={name}
            addComma={idx < students.length - 1}
          />
        );
      });

      return <>{values}</>;
    },
  },
  coach_activity_by_session: {
    studentHandle: (field_name, row) => {
      if (!row[field_name]) {
        return "";
      }
      const students = row[field_name].split(",").map((s) => s.trimEnd());
      const values = students.map((name, idx) => {
        return (
          <LinkToReport
            key={row.id}
            path="/reports/coach_activity_by_athlete"
            id="coach_activity_by_athlete"
            query={{ student_id: row.studentIds[idx], student_id_name: name }}
            label={name}
            addComma={idx < students.length - 1}
          />
        );
      });

      return <>{values}</>;
    },
  },
  facility_activity_by_session: {
    coachName: (field_name, row) => {
      if (!row[field_name]) {
        return "";
      }
      const coaches = row[field_name].map((s) => s.trimEnd());
      const values = coaches.map((name, idx) => {
        return (
          <LinkToReport
            key={row.id}
            path="/reports/facility_activity_by_coach"
            id="facility_activity_by_coach"
            query={{ coach_id: row.coachIds[idx], coach_id_name: name }}
            label={name}
            addComma={idx < coaches.length - 1}
          />
        );
      });

      return <>{values}</>;
    },
    studentHandle: (field_name, row) => {
      if (!row[field_name]) {
        return "";
      }
      const students = row[field_name].split(",").map((s) => s.trimEnd());
      const values = students.map((name, idx) => {
        return (
          <LinkToReport
            key={row.id}
            path="/reports/facility_activity_by_athlete"
            id="facility_activity_by_athlete"
            query={{ student_id: row.studentIds[idx], student_id_name: name }}
            label={name}
            addComma={idx < students.length - 1}
          />
        );
      });

      return <>{values}</>;
    },
  },
  facility_activity_by_athlete: {
    coachName: (field_name, row) => {
      if (!row[field_name]) {
        return "";
      }
      const coaches = row[field_name].split(",").map((s) => s.trimEnd());
      const values = coaches.map((name, idx) => {
        return (
          <LinkToReport
            key={row.id}
            path="/reports/facility_activity_by_coach"
            id="facility_activity_by_coach"
            query={{ coach_id: row.coachIds[idx], coach_id_name: name }}
            label={name}
            addComma={idx < coaches.length - 1}
          />
        );
      });

      return <>{values}</>;
    },
    studentHandle: (field_name, row) => {
      if (!row[field_name]) {
        return "";
      }
      const students = row[field_name].split(",").map((s) => s.trimEnd());
      const values = students.map((name, idx) => {
        return (
          <LinkToReport
            key={row.id}
            path="/reports/facility_activity_by_session"
            id="facility_activity_by_session"
            query={{ student_id: row.studentIds[idx], student_id_name: name }}
            label={name}
            addComma={idx < students.length - 1}
          />
        );
      });

      return <>{values}</>;
    },
  },
  coach_utilization: {
    utilizationDelta: (field_name, row) => {
      return <PercentageWithChange textValue={row[field_name]} />;
    },
  },
  facility_utilization: {
    name: (field_name, row) => {
      const coach = row[field_name];
      if (coach === "Comparison Period" || coach === "Current Period") {
        return coach;
      }

      return (
        <LinkToReport
          path="/reports/facility_utilization"
          id="facility_utilization"
          query={{ coach_id: row.coachId, coach_id_name: coach }}
          label={coach}
        />
      );
    },
    utilizationDelta: (field_name, row) => {
      return <PercentageWithChange textValue={row[field_name]} />;
    },
  },
};

export const formatReportValue = (reportId, field_name, row) => {
  if (!formatters[reportId]) {
    return row[field_name];
  }

  if (!formatters[reportId][field_name]) {
    return row[field_name];
  }

  return formatters[reportId][field_name](field_name, row);
};
